import script from "./ParcelRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./ParcelRoute.vue?vue&type=script&setup=true&lang=js"

import "./ParcelRoute.vue?vue&type=style&index=0&id=f3e98c92&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3e98c92"]])

export default __exports__